/* Motoparts.py · Guía de talles interactiva (tema v13, 08/10/2026).
   Tablas oficiales: catálogo Alpinestars 2026 y 2027 (páginas de talles), ficha técnica de Lola Helmets y guía de MT Helmets.
   Las medidas que carga el cliente se guardan solo en su navegador. */
(function () {
  'use strict';

  var WA = 'https://wa.me/595982150388?text=';
  var LS_KEY = 'mp-medidas-v1';

  /* ---------- Tablas oficiales ---------- */
  function seq(a, b, n, s) { var o = []; for (var i = 0; i < n; i++) o.push([a + s * i, b + s * i]); return o; }

  // Hombre, talle europeo 40 a 68 (Alpinestars, Men's apparel size chart)
  var MEN = {
    sizes: ['40', '42', '44', '46', '48', '50', '52', '54', '56', '58', '60', '62', '64', '66', '68'],
    m: {
      height: [[150, 156], [157, 163], [164, 167], [168, 171], [172, 175], [176, 179], [180, 183], [184, 187], [188, 191], [192, 195], [192, 195], [196, 199], [196, 199], [196, 199], [196, 199]],
      chest: seq(78, 82, 15, 4),
      waist: seq(64, 68, 15, 4),
      hip: [[79, 83], [83, 87], [87, 91], [91, 95], [95, 99], [99, 103], [103, 107], [107, 111], [111, 115], [115, 119], [119, 123], [123, 127], [127, 131], [131, 136], [136, 140]],
      thigh: seq(48, 49, 15, 2),
      inseam: [[71, 72], [73, 74], [75, 76], [77, 78], [79, 80], [81, 82], [83, 84], [85, 86], [87, 88], [89, 90], [89, 90], [91, 92], [91, 92], [91, 92], [91, 92]],
      arm: [[49, 50], [51, 52], [53, 54], [55, 56], [57, 58], [59, 60], [61, 62], [63, 64], [65, 66], [67, 68], [67, 68], [69, 70], [69, 70], [69, 70], [69, 70]]
    }
  };
  // Mujer, talle europeo 36 a 54 (solo para estimar medidas)
  var WOMEN = {
    m: {
      height: [[157, 160], [161, 164], [165, 168], [169, 172], [173, 176], [177, 180], [181, 184], [181, 184], [185, 188], [185, 188]],
      bust: seq(78, 82, 10, 4),
      waist: seq(58, 62, 10, 4),
      hip: seq(82, 86, 10, 4)
    }
  };
  // Talles por letra (fila INT de la tabla de hombre). Rangos interpolados sobre la tabla europea.
  var LET = {
    sizes: ['3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    eu: ['39', '41', '44', '47', '50', '53', '56', '59', '62'],
    m: {
      height: [[141, 150], [150, 160], [160, 167], [167, 173], [173, 179], [179, 184], [184, 190], [190, 194], [194, 197]],
      chest: [[72, 78], [78, 84], [84, 90], [90, 95], [95, 101], [101, 107], [107, 113], [113, 119], [119, 124]],
      waist: [[58, 64], [64, 70], [70, 76], [76, 81], [81, 87], [87, 93], [93, 99], [99, 105], [105, 110]],
      hip: [[73, 79], [79, 85], [85, 91], [91, 96], [96, 102], [102, 108], [108, 114], [114, 120], [120, 125]],
      thigh: [[46, 48], [48, 50.5], [50.5, 53.5], [53.5, 56], [56, 59], [59, 62], [62, 65], [65, 67.5], [67.5, 70.5]],
      inseam: [[69, 71], [71, 73.5], [73.5, 76.5], [76.5, 79], [79, 82], [82, 85], [85, 88], [88, 89.5], [89.5, 91]],
      arm: [[47, 49], [49, 51.5], [51.5, 54.5], [54.5, 57], [57, 60], [60, 63], [63, 66], [66, 67.5], [67.5, 69]]
    }
  };
  // Infantil 120 a 150 (Alpinestars, Youth's apparel size chart)
  var YOUTH = {
    sizes: ['120', '130', '140', '150'],
    int: ['S', 'M', 'L', 'XL'],
    edad: ['6', '7 a 8', '9 a 10', '11 a 12'],
    m: {
      height: [[120, 130], [130, 140], [140, 150], [150, 160]],
      age: [[5, 6], [7, 8], [9, 10], [11, 13]],
      chest: [[60.5, 65.5], [65.5, 70.5], [70.5, 75.5], [75.5, 80.5]],
      waist: [[54, 58], [58, 62], [62, 66], [66, 70]],
      hip: [[68, 72], [72, 76], [76, 80], [80, 84]],
      thigh: [[40, 42], [42, 44], [44, 46], [46, 48]],
      inseam: [[51.1, 56.5], [56.5, 61.5], [61.5, 66.5], [66.5, 71.5]],
      arm: [[40, 44], [44, 48], [48, 52], [52, 56]]
    }
  };
  // Protector de costillas Bionic Rib Support: S a L y XL a 3XL (contorno de pecho de la fila INT)
  var RIB = { sizes: ['S/L', 'XL/3XL'], m: { chest: [[90, 107], [107, 124]] } };
  // Guantes (contorno de palma sin el pulgar). XS de la tabla de mujer; XXS por debajo.
  var GLOVE = {
    sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    m: { hand: [[null, 16.5], [16.5, 17.8], [17.8, 20.3], [20.3, 21.6], [21.6, 22.9], [22.9, 24.1], [24.1, 25.4], [25.4, 27.9]] }
  };
  var GLOVE_Y = {
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    m: { hand: [[null, 15.6], [15.6, 16.7], [16.8, 17.5], [17.6, 18.3], [18.4, 19.1]] }
  };
  // Calzado (Alpinestars, Footwear size chart). cm = talle JPN = largo del pie.
  var SHOES = [
    ['2.5', 34, 20.5], ['3', 34.5, 21], ['3.5', 35, 21.5], ['4', 35.5, 22], ['4.5', 36, 22.5], ['5', 37, 23], ['6', 38, 24],
    ['6.5', 38.5, 24.5], ['7', 39, 25], ['7.5', 40, 25.5], ['8', 40.5, 25.5], ['8.5', 41, 26], ['9', 42, 26.5], ['9.5', 42.5, 27],
    ['10', 43, 27.5], ['10.5', 43.5, 28], ['11', 44, 28.5], ['11.5', 45, 29.5], ['12', 45.5, 29.5], ['12.5', 46, 30], ['13', 47, 30.5],
    ['13.5', 47.5, 31], ['14', 48, 31.5], ['14.5', 49, 32], ['15', 49.5, 32.5]
  ].map(function (r) { return { s: r[0], eu: r[1], cm: r[2] }; });
  // Calzado infantil (Kids' footwear size chart: US 12,5 a 2 = EU 30 a 33). cm aproximados.
  var SHOES_Y = [['12', 29.5, 18.2, 1], ['12.5', 30, 18.5], ['13.5', 31, 19.2], ['1', 32, 19.8], ['2', 33, 20.5]]
    .map(function (r) { return { s: r[0], eu: r[1], cm: r[2], aprox: !!r[3] }; });
  // Cascos: contorno de cabeza
  var HEAD = {
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    m: { head: [[53, 54], [55, 56], [57, 58], [59, 60], [61, 62], [63, 64], [65, 66]] }
  };

  /* ---------- Campos ---------- */
  var CAMPOS = {
    height: { l: 'Estatura', u: 'cm', min: 80, max: 230, step: 1, ph: '178', how: 'Descalzo, de espaldas a la pared, del piso a la coronilla.' },
    weight: { l: 'Peso', u: 'kg', min: 15, max: 220, step: 1, ph: '78', how: 'Si no medís pecho o cintura, los estimamos con tu peso y tu estatura.' },
    chest: { l: 'Pecho', u: 'cm', min: 40, max: 170, step: 0.5, ph: '100', how: 'Por la parte más ancha, debajo de las axilas, con la cinta horizontal.' },
    waist: { l: 'Cintura', u: 'cm', min: 35, max: 170, step: 0.5, ph: '86', how: 'A la altura del ombligo, sin apretar.' },
    hip: { l: 'Cadera', u: 'cm', min: 45, max: 180, step: 0.5, ph: '100', how: 'Por la parte más ancha de la cadera, unos 20 cm debajo de la cintura.' },
    inseam: { l: 'Entrepierna', u: 'cm', min: 35, max: 110, step: 0.5, ph: '81', how: 'De pie y descalzo, desde la entrepierna hasta el piso. Mejor si te ayuda otra persona.' },
    arm: { l: 'Brazo', u: 'cm', min: 30, max: 85, step: 0.5, ph: '60', how: 'Del hombro a la muñeca, con el brazo relajado al costado del cuerpo.' },
    thigh: { l: 'Muslo', u: 'cm', min: 25, max: 95, step: 0.5, ph: '58', how: 'Alrededor del muslo, justo debajo de la entrepierna.' },
    age: { l: 'Edad', u: 'años', min: 3, max: 17, step: 1, ph: '9', how: 'Solo orienta: lo que manda es la estatura.' },
    hand: { l: 'Contorno de palma', u: 'cm', min: 12, max: 32, step: 0.1, ph: '21', how: 'Alrededor de la palma en su parte más ancha, sin el pulgar. Medí la mano con la que escribís.' },
    foot: { l: 'Largo del pie', u: 'cm', min: 12, max: 35, step: 0.1, ph: '26,5', how: 'Parado, del talón a la punta del dedo más largo. Medí los dos pies y usá el más largo.' },
    eu: { l: 'Tu número habitual', u: 'EU', min: 25, max: 50, step: 0.5, ph: '42', how: 'El número europeo que usás en zapatillas (por ejemplo, 42).' },
    head: { l: 'Contorno de cabeza', u: 'cm', min: 45, max: 70, step: 0.5, ph: '57', how: 'Cinta dos dedos por encima de las cejas y por la parte más ancha de la nuca, sin apretar. Si tenés una gorra con número (57, 58), ese número es tu contorno.' }
  };
  var GIRTH = { chest: 1, waist: 1, hip: 1, thigh: 1, hand: 1, head: 1 };

  /* ---------- Tipos de producto ---------- */
  var TIPOS = {
    'mono-adulto': {
      t: 'Mamelucos de karting', chart: MEN, kind: 'body', tile: 'height', sexo: 1,
      campos: ['height', 'weight', 'chest', 'waist'], extra: ['hip', 'inseam', 'arm', 'thigh'],
      pts: { height: 30, weight: 15, chest: 25, waist: 20, hip: 10, inseam: 8, arm: 4, thigh: 3 },
      entre: 'Si vas a usar protector de costillas debajo o te gusta más holgado, elegí el {b}. Si lo querés bien ajustado, el {a}.',
      col: '/collections/trajes', colT: 'Ver mamelucos'
    },
    'ropa-letras': {
      t: 'Mamelucos indoor y de lluvia', chart: LET, kind: 'body', tile: 'height', sexo: 1, eu: 1,
      campos: ['height', 'weight', 'chest', 'waist'], extra: ['hip', 'inseam', 'arm'],
      pts: { height: 30, weight: 15, chest: 27, waist: 20, hip: 10, inseam: 8, arm: 5 },
      entre: 'El de lluvia va encima del mameluco: si dudás, elegí el {b}. En el indoor, el {b} si te gusta holgado.',
      col: '/collections/trajes', colT: 'Ver mamelucos'
    },
    'top-letras': {
      t: 'Ropa interior técnica', chart: LET, kind: 'body', tile: 'chest', sexo: 1, eu: 1,
      campos: ['height', 'weight', 'chest', 'waist'], extra: [],
      pts: { height: 25, weight: 15, chest: 45, waist: 30 },
      entre: 'Va pegada al cuerpo: el {a} si la querés ajustada, el {b} si preferís más suelta.',
      col: '/collections/accesorios-karting', colT: 'Ver accesorios'
    },
    'mono-ninos': {
      t: 'Mamelucos infantiles', chart: YOUTH, kind: 'body', tile: 'height', ninos: 1,
      campos: ['height', 'age', 'chest', 'waist'], extra: ['hip', 'inseam', 'arm', 'thigh'],
      pts: { height: 45, chest: 20, waist: 13, hip: 8, inseam: 8, arm: 3, thigh: 3 }, ptsAlone: { age: 15 },
      entre: 'Si está creciendo, llevá el {b}: le va a durar más.',
      col: '/collections/karting-infantil', colT: 'Ver karting infantil'
    },
    'costillas-adulto': {
      t: 'Protector de costillas', chart: RIB, kind: 'body', tile: 'chest', sexo: 1,
      campos: ['chest', 'height', 'weight'], extra: [],
      pts: { chest: 100, height: 15, weight: 25 },
      entre: 'Se ajusta con correas: si estás en el límite, elegí el {b}.',
      col: '/collections/protecciones', colT: 'Ver protecciones'
    },
    'guantes-adulto': {
      t: 'Guantes de karting', chart: GLOVE, kind: 'glove', tile: 'hand', sexo: 1,
      campos: ['hand', 'height'], extra: [],
      pts: { hand: 100 }, ptsAlone: { height: 25 },
      entre: 'Si te gusta el guante ajustado (más tacto en el volante), el {a}. Si tenés la mano gruesa o los dedos largos, el {b}.',
      col: '/collections/guantes', colT: 'Ver guantes'
    },
    'guantes-ninos': {
      t: 'Guantes infantiles', chart: GLOVE_Y, kind: 'glove', tile: 'hand', ninos: 1,
      campos: ['hand', 'height', 'age'], extra: [],
      pts: { hand: 100 }, ptsAlone: { height: 25, age: 15 },
      entre: 'Si está creciendo, el {b}.',
      col: '/collections/karting-infantil', colT: 'Ver karting infantil'
    },
    'calzado-adulto': {
      t: 'Calzado de karting', list: SHOES, kind: 'shoe', tile: 'foot', sexo: 1,
      campos: ['foot', 'eu', 'height'], extra: [],
      col: '/collections/calzado-karting', colT: 'Ver calzado'
    },
    'calzado-ninos': {
      t: 'Calzado infantil', list: SHOES_Y, kind: 'shoe', tile: 'foot', ninos: 1,
      campos: ['eu', 'foot'], extra: [],
      col: '/collections/karting-infantil', colT: 'Ver karting infantil'
    },
    'casco-mt': {
      t: 'Cascos MT Helmets', chart: HEAD, kind: 'head', tile: 'head',
      campos: ['head'], extra: [], col: '/collections/cascos', colT: 'Ver cascos'
    },
    'casco-lola': {
      t: 'Cascos Lola Helmets', chart: { sizes: HEAD.sizes.slice(0, 6), m: { head: HEAD.m.head.slice(0, 6) } }, kind: 'head', tile: 'head',
      campos: ['head'], extra: [], col: '/collections/lola-helmets', colT: 'Ver cascos Lola'
    }
  };
  var PESTANAS = [
    ['casco-mt', 'Cascos'], ['mono-adulto', 'Mamelucos'], ['mono-ninos', 'Mamelucos infantiles'], ['ropa-letras', 'Indoor y lluvia'],
    ['guantes-adulto', 'Guantes'], ['guantes-ninos', 'Guantes infantiles'], ['calzado-adulto', 'Calzado'], ['calzado-ninos', 'Calzado infantil'],
    ['costillas-adulto', 'Protector de costillas'], ['top-letras', 'Ropa técnica']
  ];

  /* ---------- Utilidades ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function num(v) { if (v == null) return NaN; var s = String(v).trim().replace(',', '.'); if (!s) return NaN; return parseFloat(s); }
  function fmt(n) { var r = Math.round(n * 10) / 10; return String(r).replace('.', ','); }
  function rng(r) { if (!r) return ''; if (r[0] == null) return 'hasta ' + fmt(r[1]); if (r[1] == null) return 'desde ' + fmt(r[0]); return fmt(r[0]) + ' a ' + fmt(r[1]); }
  function norm(s) {
    s = String(s || '').toUpperCase().replace(/^US\s*/, '').replace(',', '.').trim();
    if (s === '2XL') s = 'XXL'; if (s === 'XXXL') s = '3XL'; if (s === '2XS') s = 'XXS'; if (s === 'XXXS') s = '3XS';
    return s;
  }
  function leer() { try { return JSON.parse(window.localStorage.getItem(LS_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function guardar(o) { try { window.localStorage.setItem(LS_KEY, JSON.stringify(o)); } catch (e) {} }
  function borrarLS() { try { window.localStorage.removeItem(LS_KEY); } catch (e) {} }

  // posición continua de un valor dentro de una tabla de rangos (0 = primer talle)
  function bordes(rr) {
    var B = [rr[0][0]];
    for (var j = 1; j < rr.length; j++) B.push((rr[j - 1][1] + rr[j][0]) / 2);
    B.push(rr[rr.length - 1][1]);
    return B;
  }
  function posDe(rr, x) {
    var B = bordes(rr), n = B.length - 1;
    if (x <= B[0]) return (x - B[0]) / ((B[1] - B[0]) || 1);
    for (var i = 0; i < n; i++) if (x <= B[i + 1]) return i + (x - B[i]) / ((B[i + 1] - B[i]) || 1);
    return n + (x - B[n]) / ((B[n] - B[n - 1]) || 1);
  }
  function valorEn(rr, p) {
    var B = bordes(rr), n = B.length - 1;
    if (p <= 0) return B[0] + (B[1] - B[0]) * p;
    if (p >= n) return B[n] + (B[n] - B[n - 1]) * (p - n);
    var i = Math.floor(p); return B[i] + (B[i + 1] - B[i]) * (p - i);
  }

  /* ---------- Estimaciones con peso y estatura ---------- */
  function estimar(v, sexo) {
    var h = v.height, w = v.weight, out = {};
    if (!h) return out;
    var bmi = w ? w / Math.pow(h / 100, 2) : null;
    if (sexo === 'mujer') {
      var p = posDe(WOMEN.m.height, h), d = bmi ? bmi - 22 : 0;
      out.chest = valorEn(WOMEN.m.bust, p) + 1.9 * d - 4;
      out.waist = valorEn(WOMEN.m.waist, p) + 2.4 * d;
      out.hip = valorEn(WOMEN.m.hip, p) + 2.2 * d;
      out.peso = !!bmi;
    } else if (bmi) {
      var q = posDe(MEN.m.height, h), e = bmi - 24;
      out.chest = valorEn(MEN.m.chest, q) + 1.9 * e;
      out.waist = valorEn(MEN.m.waist, q) + 2.6 * e;
      out.hip = valorEn(MEN.m.hip, q) + 1.8 * e;
      out.peso = true;
    }
    return out;
  }

  /* ---------- Motor de cálculo por rangos ---------- */
  function paso(rr) {
    var a = null, b = null, n = 0;
    for (var i = 0; i < rr.length; i++) { if (rr[i][0] != null) { if (a == null) a = [i, rr[i][0]]; b = [i, rr[i][0]]; } }
    if (a && b && b[0] > a[0]) n = (b[1] - a[1]) / (b[0] - a[0]);
    if (!n) { var r = rr[rr.length - 1]; n = (r[1] - (r[0] == null ? r[1] - 1 : r[0])) || 1; }
    return Math.max(n, 0.5);
  }
  function pen(rr, i, x, st, girth) {
    var r = rr[i]; if (!r) return 0;
    var lo = r[0] == null ? -Infinity : r[0], hi = r[1] == null ? Infinity : r[1];
    if (i > 0 && rr[i - 1] && rr[i - 1][1] != null && lo > -Infinity && rr[i - 1][1] < lo) lo = (rr[i - 1][1] + lo) / 2;
    if (i < rr.length - 1 && rr[i + 1] && rr[i + 1][0] != null && hi < Infinity && rr[i + 1][0] > hi) hi = (hi + rr[i + 1][0]) / 2;
    // talle grande para esa medida: en contornos queda holgado (se ajusta con el cinturón); en largos, un poco largo
    if (x < lo) return (lo - x) / st * (girth ? 0.75 : 0.6);
    // talle chico: aprieta o queda corto, que es peor
    if (x > hi) return (x - hi) / st * 1.6;
    return 0;
  }
  function calcular(chart, meds) {
    var n = chart.sizes.length, sc = [], i;
    for (i = 0; i < n; i++) sc.push(0);
    meds.forEach(function (m) {
      var rr = chart.m[m.k]; if (!rr) return;
      var st = paso(rr); m.st = st;
      var best = Infinity, ids = [];
      for (i = 0; i < n; i++) {
        var p = pen(rr, i, m.v, st, GIRTH[m.k]);
        sc[i] += m.w * p * p;
        if (p < best - 1e-9) { best = p; ids = [i]; } else if (Math.abs(p - best) < 1e-9) ids.push(i);
      }
      m.ids = ids; m.fuera = best > 0.75 && (ids[0] === 0 || ids[ids.length - 1] === n - 1) ? (ids[0] === 0 ? -1 : 1) : 0;
    });
    var bi = 0;
    for (i = 1; i < n; i++) if (sc[i] < sc[bi] - 1e-9) bi = i;
    // empate exacto entre vecinos (por ejemplo, solo estatura en 58 y 60)
    var empate = [];
    for (i = 0; i < n; i++) if (Math.abs(sc[i] - sc[bi]) < 1e-9) empate.push(i);
    var otro = null;
    if (empate.length > 1) otro = empate[empate.length - 1] === bi ? empate[0] : empate[1];
    else {
      var cand = [bi - 1, bi + 1].filter(function (j) { return j >= 0 && j < n; });
      cand.sort(function (a, b) { return sc[a] - sc[b]; });
      if (cand.length && sc[cand[0]] - sc[bi] < 0.05 + 0.15 * sc[bi]) otro = cand[0];
    }
    return { i: bi, otro: otro, sc: sc, meds: meds };
  }

  /* ---------- Estado y render ---------- */
  function Widget(root, cfg) {
    this.root = root;
    this.cfg = cfg;
    this.modo = cfg.modo || 'ficha';
    this.vals = leer();
    this.sexo = this.vals.sexo || 'hombre';
    this.setTipo(cfg.tipo);
  }

  Widget.prototype.setTipo = function (tipo) {
    if (!TIPOS[tipo]) tipo = 'mono-adulto';
    this.tipo = tipo; this.T = TIPOS[tipo];
    this.abierto = false;
    this.render();
  };

  Widget.prototype.tallesProducto = function () {
    var T = this.T, base = T.list ? T.list.map(function (x) { return x.s; }) : T.chart.sizes;
    if (this.modo !== 'ficha' || !this.cfg.talles || !this.cfg.talles.length) return base.slice();
    var prod = this.cfg.talles.map(norm);
    var r = base.filter(function (s) { return prod.indexOf(norm(s)) >= 0; });
    return r.length ? r : base.slice();
  };

  Widget.prototype.render = function () {
    var T = this.T, self = this, h = '';
    var keyNinos = T.ninos ? 'n_' : '';
    h += '<div class="mp-gt__head"><span class="mp-gt__titulo">Guía de talles</span>';
    if (this.modo === 'ficha' && this.cfg.guia) h += '<a class="mp-gt__link" href="' + esc(this.cfg.guia) + '">Ver guía completa →</a>';
    h += '</div>';
    if (this.modo === 'guia') {
      h += '<div class="mp-gt__tabs" role="tablist" aria-label="Tipo de producto">';
      PESTANAS.forEach(function (p) {
        var on = p[0] === self.tipo || (p[0] === 'casco-mt' && self.tipo === 'casco-lola');
        h += '<button type="button" role="tab" class="mp-gt__tab' + (on ? ' is-on' : '') + '" aria-selected="' + on + '" data-tipo="' + p[0] + '">' + esc(p[1]) + '</button>';
      });
      h += '</div>';
    }
    h += '<p class="mp-gt__sub">' + this.subtitulo() + '</p>';
    if (T.kind === 'head' && this.modo === 'guia') {
      h += '<div class="mp-gt__seg" role="group" aria-label="Marca">';
      h += '<button type="button" data-marca="casco-mt" class="' + (this.tipo === 'casco-mt' ? 'is-on' : '') + '">MT Helmets</button>';
      h += '<button type="button" data-marca="casco-lola" class="' + (this.tipo === 'casco-lola' ? 'is-on' : '') + '">Lola Helmets</button>';
      h += '</div>';
    }
    h += '<div class="mp-gt__tiles" aria-hidden="true">' + this.tiles() + '</div>';
    if (T.sexo) {
      h += '<div class="mp-gt__seg" role="radiogroup" aria-label="Para quién es">';
      ['hombre', 'mujer'].forEach(function (s) {
        h += '<button type="button" role="radio" aria-checked="' + (self.sexo === s) + '" data-sexo="' + s + '" class="' + (self.sexo === s ? 'is-on' : '') + '">' + (s === 'hombre' ? 'Hombre' : 'Mujer') + '</button>';
      });
      h += '</div>';
    }
    h += '<div class="mp-gt__campos">';
    T.campos.forEach(function (k) { h += self.campo(k, keyNinos); });
    h += '</div>';
    if (T.kind === 'head') h += this.campoCasco();
    if (T.extra.length) {
      h += '<button type="button" class="mp-gt__mas" aria-expanded="false">+ Sumar más medidas (' + T.extra.map(function (k) { return CAMPOS[k].l.toLowerCase(); }).join(', ') + ')</button>';
      h += '<div class="mp-gt__campos mp-gt__extra" hidden>';
      T.extra.forEach(function (k) { h += self.campo(k, keyNinos); });
      h += '</div>';
    }
    h += '<div class="mp-gt__res" aria-live="polite"></div>';
    h += '<details class="mp-gt__tabla"><summary>Ver la tabla oficial completa</summary><div class="mp-gt__twrap">' + this.tabla() + '</div><p class="mp-gt__fuente">' + this.fuente() + '</p></details>';
    h += '<p class="mp-gt__priv">Tus medidas quedan guardadas solo en este navegador para la próxima vez. <button type="button" class="mp-gt__borrar">Borrar mis medidas</button></p>';
    this.root.innerHTML = h;
    var tabs = $('.mp-gt__tabs', this.root), on = tabs && $('.is-on', tabs);
    if (on && tabs.scrollWidth > tabs.clientWidth) tabs.scrollLeft = Math.max(0, on.offsetLeft - 16);
    this.bind();
    this.actualizar();
  };

  Widget.prototype.subtitulo = function () {
    var T = this.T;
    if (T.kind === 'body' && !T.ninos && T.chart !== RIB) return 'Cargá lo que sepas. Con tu estatura ya te damos un talle, y cada medida que sumes lo hace más preciso.';
    if (T.kind === 'body' && T.ninos) return 'Con la estatura ya tenés un talle. Si sumás pecho y cintura, más preciso.';
    if (T.chart === RIB) return 'Se elige por el contorno de pecho. Si no lo medís, lo estimamos con tu estatura y tu peso.';
    if (T.kind === 'glove') return 'Lo más preciso es el contorno de la palma. Si no tenés cinta, te orientamos con la estatura.';
    if (T.kind === 'shoe') return T.ninos ? 'Poné el número que usa en zapatillas o el largo de su pie.' : 'Poné el largo de tu pie o el número que usás en zapatillas.';
    if (T.kind === 'head') return 'Medí tu cabeza o decinos qué talle de casco usás hoy y cómo te queda.';
    return '';
  };

  Widget.prototype.fuente = function () {
    var T = this.T;
    if (T.kind === 'head') return this.tipo === 'casco-lola' ? 'Fuente: ficha técnica de Lola Helmets. Contorno de cabeza en cm.' : 'Fuente: tabla de talles de MT Helmets. Contorno de cabeza en cm.';
    if (T.chart === LET || T.chart === RIB) return 'Fuente: catálogo Alpinestars 2026 y 2027, tabla de hombre (fila de talle internacional). Medidas del cuerpo en cm; los rangos por letra son la equivalencia con el talle europeo.';
    return 'Fuente: catálogo Alpinestars 2026 y 2027, tablas de talles. Medidas del cuerpo en cm.';
  };

  Widget.prototype.campo = function (k, pref) {
    var c = CAMPOS[k], v = this.vals[pref + k], id = 'mpgt-' + Math.random().toString(36).slice(2, 7);
    var lab = c.l;
    if (k === 'chest' && this.T.sexo && this.sexo === 'mujer') lab = 'Busto';
    var how = c.how;
    if (k === 'chest' && this.T.sexo && this.sexo === 'mujer') how = 'Por la parte más llena del busto, con la cinta horizontal.';
    if (k === 'height' && (this.T.kind === 'glove' || this.T.kind === 'shoe')) how = 'Solo si no podés medir: es una estimación.';
    return '<div class="mp-gt__campo" data-k="' + k + '"><label for="' + id + '">' + esc(lab) + ' <button type="button" class="mp-gt__info" aria-label="Cómo medir ' + esc(lab.toLowerCase()) + '" aria-expanded="false">?</button></label>' +
      '<span class="mp-gt__in"><input id="' + id + '" name="' + k + '" type="text" inputmode="decimal" autocomplete="off" placeholder="' + esc(c.ph) + '" value="' + (v != null && v !== '' ? esc(fmt(v)) : '') + '"><span>' + esc(c.u) + '</span></span>' +
      '<small class="mp-gt__how" hidden>' + esc(how) + '</small></div>';
  };

  Widget.prototype.campoCasco = function () {
    var v = this.vals, sz = this.T.chart.sizes;
    var h = '<div class="mp-gt__alt"><p class="mp-gt__alt-t">¿No tenés cinta métrica?</p><div class="mp-gt__campos">';
    h += '<div class="mp-gt__campo"><label>Talle de tu casco actual</label><select name="casco_talle"><option value="">Elegí</option>';
    HEAD.sizes.forEach(function (s) { h += '<option' + (v.casco_talle === s ? ' selected' : '') + '>' + s + '</option>'; });
    h += '</select></div><div class="mp-gt__campo"><label>¿Cómo te queda?</label><select name="casco_calce"><option value="">Elegí</option>';
    [['justo', 'Firme y cómodo'], ['flojo', 'Flojo, se mueve'], ['aprieta', 'Me aprieta o me duele']].forEach(function (o) {
      h += '<option value="' + o[0] + '"' + (v.casco_calce === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
    });
    h += '</select></div></div></div>';
    void sz;
    return h;
  };

  Widget.prototype.tiles = function () {
    var T = this.T, talles = this.tallesProducto(), h = '';
    if (T.kind === 'shoe') {
      T.list.forEach(function (x) {
        if (talles.indexOf(x.s) < 0) return;
        h += '<span data-s="' + esc(x.s) + '"><b>US ' + esc(fmt(num(x.s))) + '</b>EU ' + fmt(x.eu) + ' · ' + fmt(x.cm) + ' cm</span>';
      });
      return h;
    }
    var rr = T.chart.m[T.tile];
    T.chart.sizes.forEach(function (s, i) {
      if (talles.indexOf(s) < 0) return;
      var extra = T.chart === LET && T.eu ? ' <i>≈ ' + LET.eu[i] + '</i>' : '';
      h += '<span data-s="' + esc(s) + '"><b>' + esc(s) + extra + '</b>' + esc(rng(rr[i])) + ' cm</span>';
    });
    return h;
  };

  Widget.prototype.tabla = function () {
    var T = this.T, talles = this.tallesProducto(), h = '<table><thead><tr><th>Talle</th>';
    if (T.kind === 'shoe') {
      h += '<th>EU</th><th>Largo del pie</th></tr></thead><tbody>';
      T.list.forEach(function (x) {
        if (talles.indexOf(x.s) < 0) return;
        h += '<tr data-s="' + esc(x.s) + '"><td>US ' + esc(fmt(num(x.s))) + '</td><td>' + fmt(x.eu) + '</td><td>' + fmt(x.cm) + ' cm' + (x.aprox ? ' aprox.' : '') + '</td></tr>';
      });
      return h + '</tbody></table>';
    }
    var keys = Object.keys(T.chart.m).filter(function (k) { return CAMPOS[k] || k === 'head'; });
    var idx = [];
    T.chart.sizes.forEach(function (s, i) { if (talles.indexOf(s) >= 0) idx.push(i); });
    h = '<table><thead><tr><th>Medida</th>';
    idx.forEach(function (i) { h += '<th data-s="' + esc(T.chart.sizes[i]) + '">' + esc(T.chart.sizes[i]) + (T.chart === LET && T.eu ? '<br><i>≈ ' + LET.eu[i] + '</i>' : '') + (T.chart === YOUTH ? '<br><i>' + YOUTH.int[i] + '</i>' : '') + '</th>'; });
    h += '</tr></thead><tbody>';
    keys.forEach(function (k) {
      var lab = k === 'age' ? 'Edad (años)' : CAMPOS[k].l + ' (cm)';
      h += '<tr><th scope="row">' + esc(lab) + '</th>';
      idx.forEach(function (i) {
        var r = T.chart.m[k][i];
        var t = k === 'age' ? YOUTH.edad[i] : rng(r);
        h += '<td data-s="' + esc(T.chart.sizes[i]) + '">' + esc(t) + '</td>';
      });
      h += '</tr>';
    });
    return h + '</tbody></table>';
  };

  Widget.prototype.bind = function () {
    var self = this, R = this.root, t;
    $$('input', R).forEach(function (inp) {
      inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { self.leerCampos(); self.actualizar(); }, 160); });
    });
    $$('select', R).forEach(function (s) { s.addEventListener('change', function () { self.leerCampos(); self.actualizar(); }); });
    $$('[data-sexo]', R).forEach(function (b) {
      b.addEventListener('click', function () {
        self.leerCampos(); self.sexo = b.getAttribute('data-sexo'); self.vals.sexo = self.sexo; guardar(self.vals);
        var ab = self.abierto; self.render(); if (ab) self.abrirExtra(true);
      });
    });
    $$('[data-tipo]', R).forEach(function (b) { b.addEventListener('click', function () { self.leerCampos(); self.setTipo(b.getAttribute('data-tipo')); self.marcarUrl(); }); });
    $$('[data-marca]', R).forEach(function (b) { b.addEventListener('click', function () { self.leerCampos(); self.setTipo(b.getAttribute('data-marca')); self.marcarUrl(); }); });
    $$('.mp-gt__info', R).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var how = b.closest('.mp-gt__campo').querySelector('.mp-gt__how'); var on = how.hidden;
        how.hidden = !on; b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
    var det = $('.mp-gt__tabla', R);
    if (det) det.addEventListener('toggle', function () { if (det.open) self.centrar(); });
    var mas = $('.mp-gt__mas', R);
    if (mas) mas.addEventListener('click', function () { self.abrirExtra(!self.abierto); });
    var bor = $('.mp-gt__borrar', R);
    if (bor) bor.addEventListener('click', function () { borrarLS(); self.vals = {}; self.sexo = 'hombre'; self.render(); });
    // abrir extra si ya hay medidas guardadas
    var pref = this.T.ninos ? 'n_' : '';
    if (this.T.extra.some(function (k) { return self.vals[pref + k]; })) this.abrirExtra(true);
  };

  Widget.prototype.abrirExtra = function (on) {
    var mas = $('.mp-gt__mas', this.root), ex = $('.mp-gt__extra', this.root);
    if (!mas || !ex) return;
    this.abierto = on; ex.hidden = !on; mas.setAttribute('aria-expanded', on ? 'true' : 'false');
    mas.textContent = on ? '− Menos medidas' : '+ Sumar más medidas (' + this.T.extra.map(function (k) { return CAMPOS[k].l.toLowerCase(); }).join(', ') + ')';
  };

  Widget.prototype.marcarUrl = function () {
    if (this.modo !== 'guia' || !window.history || !history.replaceState) return;
    try { var u = new URL(location.href); u.searchParams.set('tipo', this.tipo); history.replaceState(null, '', u.toString()); } catch (e) {}
  };

  Widget.prototype.leerCampos = function () {
    var self = this, pref = this.T.ninos ? 'n_' : '';
    $$('input[name]', this.root).forEach(function (inp) {
      var k = inp.name, c = CAMPOS[k], v = num(inp.value), campo = inp.closest('.mp-gt__campo');
      if (k === 'height' && v > 0 && v < 3) v = v * 100; // 1,78 m
      var ok = !isNaN(v) && v >= c.min && v <= c.max;
      if (campo) campo.classList.toggle('is-error', !isNaN(v) && !ok);
      if (ok) self.vals[pref + k] = v; else delete self.vals[pref + k];
    });
    $$('select[name]', this.root).forEach(function (s) { if (s.value) self.vals[s.name] = s.value; else delete self.vals[s.name]; });
    this.vals.sexo = this.sexo;
    guardar(this.vals);
  };

  Widget.prototype.v = function (k) { var pref = this.T.ninos ? 'n_' : ''; return this.vals[pref + k]; };

  /* ---------- Cálculo según tipo ---------- */
  Widget.prototype.actualizar = function () {
    var T = this.T, r;
    if (T.kind === 'body') r = this.calcBody();
    else if (T.kind === 'glove') r = this.calcGlove();
    else if (T.kind === 'shoe') r = this.calcShoe();
    else r = this.calcHead();
    this.mostrar(r);
  };

  Widget.prototype.calcBody = function () {
    var T = this.T, self = this, meds = [], info = [], vals = {}, pts = 0;
    var keys = T.campos.concat(T.extra);
    keys.forEach(function (k) { var x = self.v(k); if (x != null) vals[k] = x; });
    if (T.sexo && this.sexo === 'mujer' && vals.chest != null) { vals.chestReal = vals.chest; vals.chest = vals.chest - 4; } // busto a pecho
    var w = { height: 1, chest: 1, waist: 0.9, hip: this.sexo === 'mujer' ? 0.9 : 0.7, inseam: 0.7, arm: 0.5, thigh: 0.4, age: 0.6 };
    Object.keys(vals).forEach(function (k) {
      if (k === 'chestReal' || k === 'weight') return;
      if (k === 'age' && vals.height != null) return;
      if (!T.chart.m[k]) return;
      meds.push({ k: k, v: vals[k], w: w[k] || 0.5 });
    });
    keys.forEach(function (k) {
      if (vals[k] == null) return;
      if (k === 'weight') {
        if (vals.height != null) pts += (vals.chest == null && vals.waist == null) ? (T.pts.weight || 0) : ((vals.chest == null || vals.waist == null) ? Math.round((T.pts.weight || 0) / 2) : 0);
        return;
      }
      if (k === 'age') { if (vals.height == null && T.ptsAlone) pts += T.ptsAlone.age || 0; return; }
      pts += T.pts[k] || 0;
    });
    if (T.sexo) {
      var est = estimar(vals, this.sexo);
      ['chest', 'waist', 'hip'].forEach(function (k) {
        if (vals[k] == null && est[k] != null && T.chart.m[k] && (est.peso || self.sexo === 'mujer')) {
          meds.push({ k: k, v: est[k], w: est.peso ? 0.6 : 0.35, est: 1 });
        }
      });
    }
    if (!meds.length) return { vacio: 1, pts: 0 };
    var res = calcular(T.chart, meds);
    res.pts = Math.min(100, pts);
    res.vals = vals;
    return res;
  };

  Widget.prototype.calcGlove = function () {
    var T = this.T, hand = this.v('hand'), h = this.v('height'), age = this.v('age'), meds = [], pts = 0, nota = '';
    if (hand != null) { meds.push({ k: 'hand', v: hand, w: 1 }); pts = 100; }
    else if (T.ninos && (h != null || age != null)) {
      var i = h != null ? Math.max(0, Math.min(3, Math.floor(posDe(YOUTH.m.height, h)))) : Math.max(0, Math.min(3, Math.floor(posDe(YOUTH.m.age, age))));
      var rr = GLOVE_Y.m.hand[i + 1];
      meds.push({ k: 'hand', v: (rr[0] + rr[1]) / 2, w: 1, est: 1 });
      pts = h != null ? 25 : 15; nota = 'Estimado por ' + (h != null ? 'la estatura' : 'la edad') + ' (mismo talle internacional que el mameluco infantil).';
    } else if (h != null) {
      var est = this.sexo === 'mujer' ? 18.9 + 0.07 * (h - 166) : 21.6 + 0.075 * (h - 176);
      meds.push({ k: 'hand', v: est, w: 1, est: 1 }); pts = 25; nota = 'Estimado por tu estatura: medí la palma para confirmarlo.';
    }
    if (!meds.length) return { vacio: 1, pts: 0 };
    var res = calcular(T.chart, meds); res.pts = pts; res.nota = nota; res.vals = { hand: hand, height: h, age: age };
    return res;
  };

  Widget.prototype.calcShoe = function () {
    var T = this.T, L = this.v('foot'), E = this.v('eu'), h = this.v('height');
    var lista = T.list;
    var pts = 0, nota = '', base = null;
    if (L != null) { base = L; pts = 100; }
    else if (E != null) {
      var ex = null;
      T.list.forEach(function (x) { if (ex == null && x.eu >= E - 0.01) ex = x; });
      if (!ex) ex = T.list[T.list.length - 1];
      base = ex.cm - 0.01; pts = 70; nota = 'Por tu número habitual EU ' + fmt(E) + '. Cada marca calza distinto: si podés, medí el pie.';
    } else if (h != null && !T.ninos) {
      base = (this.sexo === 'mujer' ? 0.150 : 0.152) * h; pts = 20; nota = 'Estimado por tu estatura (aprox. ' + fmt(base) + ' cm de pie). Medí el pie para confirmarlo.';
    }
    if (base == null) return { vacio: 1, pts: 0 };
    var elegido = null, sig = null;
    for (var i = 0; i < lista.length; i++) { if (lista[i].cm >= base - 0.05) { elegido = lista[i]; sig = lista[i + 1] || null; break; } }
    var fuera = 0;
    if (!elegido) { elegido = lista[lista.length - 1]; fuera = 1; }
    else if (lista[0] === elegido && base < elegido.cm - 1.2) fuera = -1;
    var justo = L != null && elegido.cm - L < 0.3 && sig;
    return { shoe: 1, el: elegido, alt: justo ? sig : null, pts: pts, nota: nota, fuera: fuera, L: L, E: E, base: base };
  };

  Widget.prototype.calcHead = function () {
    var T = this.T, x = this.v('head'), sz = T.chart.sizes, rr = T.chart.m.head, i, n = sz.length;
    var talle = this.vals.casco_talle, calce = this.vals.casco_calce;
    if (x != null) {
      if (x < rr[0][0] - 0.5) return { head: 1, i: 0, fuera: -1, pts: 100, x: x };
      if (x > rr[n - 1][1] + 0.5) return { head: 1, i: n - 1, fuera: 1, pts: 100, x: x };
      for (i = 0; i < n; i++) {
        if (x >= rr[i][0] - 0.001 && x <= rr[i][1] + 0.001) return { head: 1, i: i, pts: 100, x: x };
        if (i < n - 1 && x > rr[i][1] && x < rr[i + 1][0]) return { head: 1, i: i, otro: i + 1, pts: 100, x: x };
      }
      return { head: 1, i: x < rr[0][0] ? 0 : n - 1, pts: 100, x: x };
    }
    if (talle) {
      var j = HEAD.sizes.indexOf(talle);
      if (calce === 'flojo') j -= 1; else if (calce === 'aprieta') j += 1;
      var k = sz.indexOf(HEAD.sizes[Math.max(0, Math.min(HEAD.sizes.length - 1, j))]);
      var fuera = 0;
      if (k < 0) { fuera = j < 0 ? -1 : 1; k = j < 0 ? 0 : n - 1; }
      return { head: 1, i: k, pts: calce ? 55 : 40, porCasco: 1, calce: calce, talle: talle, fuera: fuera };
    }
    return { vacio: 1, pts: 0 };
  };

  /* ---------- Resultado ---------- */
  Widget.prototype.nivel = function (p) {
    if (p >= 85) return ['Muy precisa', 4];
    if (p >= 60) return ['Buena', 3];
    if (p >= 35) return ['Media', 2];
    return ['Orientativa', 1];
  };

  Widget.prototype.sugerencia = function (r) {
    var T = this.T, self = this;
    if (T.kind === 'body') {
      var faltan = T.campos.concat(T.extra).filter(function (k) {
        if (k === 'weight' && (self.v('height') == null || (self.v('chest') != null && self.v('waist') != null))) return false;
        if (k === 'age') return false;
        return self.v(k) == null && T.pts[k];
      });
      faltan.sort(function (a, b) { return T.pts[b] - T.pts[a]; });
      if (!faltan.length) return '';
      var k = faltan[0], lab = (k === 'chest' && T.sexo && this.sexo === 'mujer') ? 'tu busto' : (k === 'weight' ? 'tu peso' : (k === 'height' ? 'la estatura' : 'tu ' + CAMPOS[k].l.toLowerCase()));
      if (T.ninos && k !== 'height') lab = lab.replace('tu ', 'su ');
      return 'Para afinar más, sumá ' + lab + '.';
    }
    if (T.kind === 'glove' && r.pts < 100) return 'Para afinar, medí el contorno de la palma.';
    if (T.kind === 'shoe' && r.pts < 100) return 'Para afinar, medí el largo del pie.';
    if (T.kind === 'head' && r.pts < 100) return 'Para afinar, medí tu cabeza con una cinta o un hilo.';
    return '';
  };

  Widget.prototype.mostrar = function (r) {
    var T = this.T, R = this.root, res = $('.mp-gt__res', R), self = this;
    $$('.mp-gt__tiles span, .mp-gt__tabla [data-s]', R).forEach(function (e) { e.classList.remove('is-sug', 'is-alt'); });
    if (!r || r.vacio) {
      res.innerHTML = '<p class="mp-gt__vacio">' + (T.kind === 'head' ? 'Escribí tu medida y te decimos qué talle llevar.' : 'Escribí tus medidas y te decimos qué talle llevar.') + '</p>';
      return;
    }
    var talle, alt = null, sizes, h = '', fuera = 0, porque = [], notaExtra = '';
    if (r.shoe) {
      talle = r.el.s; alt = r.alt ? r.alt.s : null; fuera = r.fuera;
      var etq = 'US ' + fmt(num(talle));
      porque.push((r.L != null ? 'Pie ' + fmt(r.L) + ' cm' : (r.E != null ? 'EU ' + fmt(r.E) : 'Estatura')) + ' → ' + etq + ' (EU ' + fmt(r.el.eu) + ', ' + fmt(r.el.cm) + ' cm)');
      if (r.nota) notaExtra = r.nota;
      if (alt) notaExtra += (notaExtra ? ' ' : '') + 'Tu pie queda justo en el US ' + fmt(num(talle)) + ': si usás medias gruesas o tenés el pie ancho, el US ' + fmt(num(alt)) + '.';
      if (r.L != null && r.E != null) {
        var porEu = null; T.list.forEach(function (x) { if (porEu == null && x.eu >= r.E - 0.01) porEu = x; });
        if (porEu && porEu.s !== talle) notaExtra += ' Ojo: por tu número habitual (EU ' + fmt(r.E) + ') sería el US ' + fmt(num(porEu.s)) + '. Manda la medida del pie.';
      }
    } else if (r.head) {
      sizes = T.chart.sizes; talle = sizes[r.i]; alt = r.otro != null ? sizes[r.otro] : null; fuera = r.fuera || 0;
      if (r.porCasco) {
        porque.push('Tu casco actual ' + r.talle + (r.calce === 'flojo' ? ', flojo' : r.calce === 'aprieta' ? ', te aprieta' : r.calce === 'justo' ? ', firme y cómodo' : '') + ' → ' + talle);
        notaExtra = 'Cada marca y modelo calza distinto: si podés, medí tu cabeza para confirmarlo.';
      } else {
        porque.push('Cabeza ' + fmt(r.x) + ' cm → ' + (alt ? talle + ' o ' + alt : talle));
      }
      if (alt) notaExtra = 'Estás entre ' + talle + ' y ' + alt + '. Te recomendamos el ' + talle + ': un casco nuevo tiene que quedar firme y el interior cede con el uso. Si te aprieta tanto que duele, cambialo por el ' + alt + ' (tenés cambio de talle).';
    } else {
      sizes = T.chart.sizes; talle = sizes[r.i]; alt = r.otro != null ? sizes[r.otro] : null;
      r.meds.forEach(function (m) {
        if (m.fuera && !m.est && m.ids.indexOf(r.i) >= 0) fuera = m.fuera;
        var lab = m.k === 'chest' && T.sexo && self.sexo === 'mujer' ? 'Busto' : CAMPOS[m.k].l;
        var val = m.k === 'chest' && r.vals && r.vals.chestReal != null && !m.est ? r.vals.chestReal : m.v;
        if (m.k === 'chest' && m.est && self.sexo === 'mujer') { lab = 'Busto'; val = m.v + 4; }
        var a = sizes[m.ids[0]], b = sizes[m.ids[m.ids.length - 1]];
        var dest = a === b ? a : a + ' a ' + b;
        var estTxt = (m.k === 'waist' || m.k === 'hip') ? ' estimada ≈ ' : ' estimado ≈ ';
        porque.push((m.est ? lab + estTxt + Math.round(val) : lab + ' ' + fmt(val)) + ' ' + (CAMPOS[m.k].u) + ' → ' + dest);
      });
      if (T.kind === 'glove' && r.nota) notaExtra = r.nota;
      if (alt) {
        var a1 = sizes.indexOf(talle) < sizes.indexOf(alt) ? talle : alt, b1 = a1 === talle ? alt : talle;
        notaExtra += (notaExtra ? ' ' : '') + 'Estás entre ' + a1 + ' y ' + b1 + '. ' + T.entre.replace(/\{a\}/g, a1).replace(/\{b\}/g, b1);
      }
      // medidas que no coinciden en un mismo talle (2 talles o más de diferencia)
      var reales = r.meds.filter(function (m) { return !m.est; });
      if (reales.length > 1) {
        var mn = reales[0], mx = reales[0];
        reales.forEach(function (m) { if (m.ids[0] < mn.ids[0]) mn = m; if (m.ids[0] > mx.ids[0]) mx = m; });
        if (mx.ids[0] - mn.ids[0] >= 2) {
          var nom = function (m) { return (m.k === 'chest' && T.sexo && self.sexo === 'mujer' ? 'busto' : CAMPOS[m.k].l.toLowerCase()) + ' ' + sizes[m.ids[0]]; };
          notaExtra += (notaExtra ? ' ' : '') + 'Tus medidas no caen en un mismo talle (' + nom(mn) + ', ' + nom(mx) + '). Te recomendamos el ' + talle +
            (GIRTH[mx.k] ? (T.ninos ? ' para que no le apriete.' : ' para que no te apriete.' + (self.tipo === 'mono-adulto' || self.tipo === 'ropa-letras' ? ' Un mameluco justo incomoda al sentarte en el kart.' : '')) : (T.ninos ? ' para que no le quede corto.' : ' para que no te quede corto.')) + ' Si querés, escribinos y lo vemos juntos.';
        }
      }
    }

    var talles = this.tallesProducto(), enProd = this.modo !== 'ficha' || talles.map(norm).indexOf(norm(talle)) >= 0;
    var disp = this.cfg.disp ? this.cfg.disp.map(norm) : null;
    var stockTxt = '';
    if (this.modo === 'ficha') {
      if (!enProd) {
        var todos = T.list ? T.list.map(function (x) { return x.s; }) : T.chart.sizes, ti = todos.indexOf(talle), cerca = null, dmin = 99;
        talles.forEach(function (s) { var d = todos.indexOf(s) - ti; var ad = Math.abs(d) - (d > 0 ? 0.1 : 0); if (ad < dmin) { dmin = ad; cerca = s; } });
        stockTxt = 'Este modelo no viene en ' + this.etq(talle) + (cerca ? '; el más cercano es el ' + this.etq(cerca) : '') + '. Escribinos y te ayudamos a elegir o lo pedimos.';
      }
      else if (disp && disp.indexOf(norm(talle)) < 0) stockTxt = 'Ese talle está sin stock por ahora: escribinos y te avisamos cuando vuelva.';
    }
    var nv = this.nivel(r.pts);
    h += '<div class="mp-gt__card">';
    h += '<div class="mp-gt__top"><div><span class="mp-gt__lbl">Tu talle' + (T.kind === 'shoe' ? '' : '') + '</span><span class="mp-gt__talle">' + esc(this.etq(talle)) + '</span>';
    if (T.chart === LET && T.eu) h += '<span class="mp-gt__eq">≈ talle europeo ' + LET.eu[LET.sizes.indexOf(talle)] + '</span>';
    if (T.chart === YOUTH) h += '<span class="mp-gt__eq">' + YOUTH.int[r.i] + ' internacional</span>';
    h += '</div>';
    h += '<div class="mp-gt__prec"><span class="mp-gt__lbl">Precisión</span><span class="mp-gt__barra n' + nv[1] + '" role="img" aria-label="Precisión ' + nv[0] + '"><i></i><i></i><i></i><i></i></span><span class="mp-gt__nv">' + nv[0] + '</span></div></div>';
    if (fuera) h += '<p class="mp-gt__alerta">' + (fuera < 0 ? 'Tus medidas quedan por debajo del talle más chico de la tabla.' : 'Tus medidas superan el talle más grande de la tabla.') +
      (fuera > 0 && this.tipo === 'mono-ninos' ? ' Desde 160 cm conviene mirar los mamelucos de adulto.' : '') +
      (fuera < 0 && this.tipo === 'mono-adulto' ? ' Si es para un chico, mirá los mamelucos infantiles.' : '') + ' Escribinos y te ayudamos a elegir.</p>';
    if (porque.length) h += '<ul class="mp-gt__porque">' + porque.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul>';
    if (notaExtra) h += '<p class="mp-gt__nota">' + esc(notaExtra) + '</p>';
    if (stockTxt) h += '<p class="mp-gt__alerta">' + esc(stockTxt) + '</p>';
    var sug = this.sugerencia(r);
    if (sug) h += '<p class="mp-gt__sug">' + esc(sug) + '</p>';
    h += '<div class="mp-gt__acc">';
    if (this.modo === 'ficha' && enProd && !fuera) h += '<button type="button" class="mp-gt__btn" data-elegir="' + esc(talle) + '">Elegir talle ' + esc(this.etq(talle)) + '</button>';
    if (this.modo === 'guia' && T.col) h += '<a class="mp-gt__btn" href="' + T.col + '">' + esc(T.colT) + '</a>';
    h += '<a class="mp-gt__wa" href="' + WA + encodeURIComponent(this.mensajeWA(talle)) + '" target="_blank" rel="noopener">Confirmar por WhatsApp</a>';
    h += '</div><p class="mp-gt__ok" hidden></p></div>';
    res.innerHTML = h;

    // resaltar
    $$('.mp-gt__tiles span, .mp-gt__tabla [data-s]', R).forEach(function (e) {
      var s = e.getAttribute('data-s');
      if (s === talle) e.classList.add('is-sug'); else if (alt && s === alt) e.classList.add('is-alt');
    });
    this.centrar();
    var btn = $('[data-elegir]', res);
    if (btn) btn.addEventListener('click', function () { self.elegir(talle, btn); });
  };

  // centrar el talle recomendado en la fila de talles y en la tabla
  Widget.prototype.centrar = function () {
    [$('.mp-gt__tiles', this.root), $('.mp-gt__twrap', this.root)].forEach(function (box) {
      if (!box) return;
      var el = box.querySelector('.is-sug');
      if (el && box.scrollWidth > box.clientWidth) {
        var x = el.offsetLeft - box.clientWidth / 2 + el.offsetWidth / 2;
        box.scrollLeft = Math.max(0, x);
      }
    });
  };

  Widget.prototype.etq = function (s) { return this.T.kind === 'shoe' ? 'US ' + fmt(num(s)) : s; };

  Widget.prototype.mensajeWA = function (talle) {
    var T = this.T, self = this, partes = [], pref = T.ninos ? 'n_' : '';
    var keys = (T.campos || []).concat(T.extra || []);
    keys.forEach(function (k) {
      var v = self.vals[pref + k]; if (v == null) return;
      var lab = k === 'chest' && T.sexo && self.sexo === 'mujer' ? 'busto' : CAMPOS[k].l.toLowerCase();
      partes.push(lab + ' ' + fmt(v) + ' ' + CAMPOS[k].u);
    });
    if (T.kind === 'head' && this.vals.casco_talle) partes.push('uso casco talle ' + this.vals.casco_talle + (this.vals.casco_calce ? ' (' + this.vals.casco_calce + ')' : ''));
    var prod = this.cfg.producto ? ' para ' + this.cfg.producto : ' (' + T.t.toLowerCase() + ')';
    return 'Hola, quiero confirmar mi talle' + prod + '.' + (T.sexo ? ' Es para ' + (this.sexo === 'mujer' ? 'mujer' : 'hombre') + '.' : '') +
      (partes.length ? ' Mis medidas: ' + partes.join(', ') + '.' : '') + ' La guía me recomienda ' + this.etq(talle) + '.';
  };

  Widget.prototype.elegir = function (talle, btn) {
    var hecho = false, alias = { XXL: ['2XL', 'XXL'], '3XL': ['XXXL', '3XL'], XXS: ['2XS', 'XXS'] };
    var buscados = [talle, 'US ' + talle].concat(alias[talle] || []);
    var ok = $('.mp-gt__ok', this.root);
    $$('product-info variant-selects fieldset, variant-selects fieldset, variant-radios fieldset').forEach(function (fs) {
      if (hecho) return;
      var lg = fs.querySelector('legend'); if (!lg || !/tall[ae]|size/i.test(lg.textContent)) return;
      $$('input', fs).forEach(function (inp) {
        if (hecho) return;
        if (buscados.map(norm).indexOf(norm(inp.value)) >= 0) {
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          (lab || inp).click(); hecho = true;
        }
      });
    });
    if (!hecho) {
      $$('variant-selects select, variant-radios select').forEach(function (s) {
        if (hecho) return;
        Array.prototype.forEach.call(s.options, function (o) {
          if (!hecho && buscados.map(norm).indexOf(norm(o.value)) >= 0) { s.value = o.value; s.dispatchEvent(new Event('change', { bubbles: true })); hecho = true; }
        });
      });
    }
    if (hecho) {
      ok.hidden = false;
      ok.innerHTML = 'Listo, elegiste el talle ' + esc(this.etq(talle)) + '. <button type="button" class="mp-gt__ir">Ir a comprar ↑</button>';
      var ir = $('.mp-gt__ir', ok);
      ir.addEventListener('click', function () {
        var b = document.querySelector('product-info .product-form__submit') || document.querySelector('.product-form__submit');
        if (b) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (e) {} }, 400); }
      });
    } else {
      ok.hidden = false; ok.textContent = 'Elegilo arriba, en el selector de talle.';
    }
    void btn;
  };

  /* ---------- Inicio ---------- */
  function iniciar() {
    $$('.mp-gt[data-cfg]').forEach(function (root) {
      if (root.getAttribute('data-ok')) return;
      root.setAttribute('data-ok', '1');
      var cfg = {};
      try { cfg = JSON.parse(root.getAttribute('data-cfg')) || {}; } catch (e) {}
      if (cfg.modo === 'guia') {
        try { var t = new URLSearchParams(location.search).get('tipo'); if (t && TIPOS[t]) cfg.tipo = t; } catch (e) {}
      }
      new Widget(root, cfg);
    });
    // enlace "¿Qué talle me queda?" de la ficha: baja hasta la guía
    $$('a[href="#mp-gt"]').forEach(function (a) {
      if (a.getAttribute('data-ok')) return; a.setAttribute('data-ok', '1');
      a.addEventListener('click', function (e) {
        var g = document.getElementById('mp-gt'); if (!g) return;
        e.preventDefault(); g.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(function () { var i = g.querySelector('input'); if (i) try { i.focus({ preventScroll: true }); } catch (er) {} }, 500);
      });
    });
  }
  window.MPGuiaTalles = { iniciar: iniciar, _t: { TIPOS: TIPOS, calcular: calcular, estimar: estimar } };
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
})();
